<template>
<div class="group-panel">

    <div class="group-heading" :class="{collapsed: collapsed}" @click="toggleCollapse">
        <div class="group-heading-label">{{schema.label}}
            <v-icon style="margin-top:-3px" class="collapse-button" :class="{collapsed:collapsed}" small >mdi-chevron-up</v-icon>
        </div>
    </div>

    <v-expand-transition>
        <div v-if="schema && !collapsed" class="pt-3 pl-3">
            <ControlList
                :horizontal="schema.horizontal"
                :schema="schemaFields" 
                :value="value"
                @change="emitChanges"
            />
        </div>
    </v-expand-transition>
</div>

</template>

<script>
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import AlertHelpers from '../../helpers/AlertHelpers'
import draggable from 'vuedraggable'

export default {
    data() {
        return {
            collapsed: false,
        }
    },

    components: {
        ConfirmIcon, draggable
    },
    
    props: {
        schema: Object,
        value: {
            type: Object,
            default: function() {
                return {}
            },
        } 
    },

    computed: {

        columnStyle() {
            const style = {}
            if(this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px'
            }
            return style
        },

        schemaFields() {
            this.schema.fields.forEach(field => {
                field._root = this.schema._root
            })
            return this.schema.fields
        },

        readOnly() {
            return Boolean(this.schema._root.readOnly)
        },

        itemCount() {
            if(this.value)
                return this.value.length
            else
                return 0
        }
   
    },

    methods: {
        emitChanges(newVal) {  
            console.log('Section emitting changes', newVal)
            this.$emit('change', newVal)
        },
        toggleCollapse() {
            this.collapsed = !this.collapsed
        },
    },

    created() {

    }
}
</script>

<style scoped>  

.group-panel {
    border: solid 1px #ddd;
    border-radius:5px;
    margin-bottom:22px;
    background-color:rgba(0,0,0,0.02);
}

.group-heading {
    color: #666;
    background-color:rgba(0,0,0,0.02);   
    position: relative;
    overflow: hidden;
    border-radius: 5px 5px 0 0; 
    user-select: none;
}

.group-heading.collapsed {
    border-radius: 5px 5px 5px 5px; 
}

.group-heading-label {
    display:inline-block;
    padding:  8px 20px;
}

.group-heading-buttons {
    text-align:right;
    position:absolute;
    right:0;
    display:inline-flex;
    transition: right .3s ease-in-out;
}

.group-heading-buttons.collapsed {
    right:-100px;
}

.group-heading-button {
    padding:8px 16px;
    display: inline-block;
    border-left: solid 1px #ddd;
}

.group-heading-button:hover, .group-heading:hover {
    background-color: rgba(0,0,0,0.03);
}

.group-item-area {
    position:relative;
    padding: 22px 20px 0px 20px; 
    border-top: solid 1px #ddd;
}

.group-item-area.read-only {
    position:relative;
    padding: 10px 10px 0px 10px;
}

.group-item-area.columns {
    padding: 10px 20px 10px 10px; 
}

.columns {
    display:flex;flex-wrap:wrap;
}
.columns > .group-item-area {
    flex-grow: 1;
    flex-shrink: 1;
}


.collapse-button {
    transition: transform .5s ease-in-out;
}
.collapse-button.collapsed {
    transform: rotate(180deg);
}


   
</style>



// WEBPACK FOOTER //
// SectionControl.vue?f286a2ae